import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import rNameLogo from "../../../assets/Reppi.svg";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogoClick = () => {
    navigate("/home");
  };

  const handleMobileNavClick = path => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleGetDemo = () => {
    window.location.href = "mailto:help@reppi.co";
  };

  const handleLogin = () => {
    navigate("/login");
  };

  // Navigation links matching the design
  const navLinks = [
    // { path: "/features/training", label: "Training" },
    // { path: "/features/recruiting", label: "Recruiting" },
    // { path: "/features/performance", label: "Performance" },
    // { path: "/features/communication", label: "Communication" },
  ];

  return (
    <nav className="navbar-component-main">
      <div className="navbar-component-content">
        {/* Left side - Always show full Reppi logo */}
        <div className="navbar-component-left">
          <button
            className="navbar-component-brand"
            onClick={handleLogoClick}
            aria-label="Go to home"
          >
            <img
              src={rNameLogo}
              alt="Reppi"
              className="navbar-component-logo"
            />
          </button>
        </div>

        {/* Desktop navigation */}
        <div className="navbar-component-menu navbar-component-desktop-only">
          <div className="navbar-component-links">
            {navLinks.map(link => (
              <button
                key={link.path}
                className={`navbar-component-link ${location.pathname === link.path ? "active" : ""}`}
                onClick={() => navigate(link.path)}
              >
                {link.label}
              </button>
            ))}
          </div>
          <div className="navbar-component-actions">
            <button className="btn btn-md btn-primary" onClick={handleGetDemo}>
              Get Demo
            </button>
            <button
              className="btn btn-md btn-outline-primary"
              onClick={handleLogin}
            >
              Log In
            </button>
          </div>
        </div>

        {/* Right side - Login button (mobile and desktop) */}
        <div className="navbar-component-right navbar-component-mobile-only">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={handleLogin}
          >
            Log In
          </button>
        </div>

        {/* Mobile dropdown menu */}
        <div
          className={`navbar-component-mobile-menu ${isMobileMenuOpen ? "open" : ""}`}
        >
          <div className="navbar-component-mobile-menu-content">
            {navLinks.map(link => (
              <button
                key={link.path}
                className={`navbar-component-mobile-link ${location.pathname === link.path ? "active" : ""}`}
                onClick={() => handleMobileNavClick(link.path)}
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
